import React from 'react';
import { Navbar } from '../../components/navbar';
import { Footer } from '../../components/footer';

import ubi_full_case from '../../assets/images/Sorbet-Full-Case.png'
import ubi_logo from '../../assets/images/Sorbet-large.png'
import './style.css'
import '../page-style.css'
import { useNavigate } from 'react-router-dom';
import Sorbet_full_case_study from '../../assets/downloads/Sorbet-Full-casestudy.pdf';
import Sorbet_summary from '../../assets/downloads/Sorbet-Summary.pdf';
import {BsArrowLeft} from 'react-icons/bs';


const P1 = "Propelled by its founder’s focus on culture, the chain of beauty salons has since expanded its franchised salons to more than 220 stores across South Africa."
const P2 = "Delivering exceptional financial results through corporate culture– How a founder’s focus on people helped build Africa’s largest beauty chain"
const P3 = "Delivering exceptional financial results through corporate culture– How a founder’s focus on people helped build Africa’s largest beauty chain"

export const SORBETGROUP = () => {
    const navigate = useNavigate();
    const handleEnter = ()=>{
        navigate("/case-studies")
    }
    const onButtonClick = (typeOfCase) => {
        fetch(typeOfCase).then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = typeOfCase;
                alink.click();
            })
        })
    }
    return (
        <div className={'main'}>
            <Navbar whiteText={false} className={'home-navbar'} />
            <div className='section-Study'>      
                <div className='study-img-card'>
                    <img src={ubi_logo} alt={'ubi'} className='ubi-enegry-image' /> 
                    <div className='ubi-text'>
                        Sorbet Group
                    </div>
                    <div className= 'casestudy-text'> {P1}</div> 
                </div>

                <div className='card'>
                    <div className='study-container study-card'>
                        <img className='book-pic' alt='book-pic' src={ubi_full_case} />
                        <h1 className='case-study-header'>Sorbet Group: Full case study</h1>
                        <p className='case-page-text partner-text'>
                            {P2}
                        </p>
                        <button className='download-casestudy hover-green' onClick={() => onButtonClick(Sorbet_full_case_study)}>Download full case study</button>
                    </div>
                    
                    <div className='study-container study-card'>
                        <img className='book-pic' alt='book-pic' src={ubi_full_case} />
                        <h1 className='case-study-header'>Sorbet Group: Executive Summary</h1>
                        <p className='case-page-text partner-text'>
                            {P3}
                        </p>
                        <button className='download-casestudy hover-green'onClick={() => onButtonClick(Sorbet_summary)}>Download executive summary</button>
                    </div>
                    
                </div>
            </div>

           <div className='section-stats'>
            <div className='stat'>
                <h1 className='stat-header'>
                    2005
                </h1>
                <p1 className="stat-text">
                     Year founded
                </p1>
            </div>
            <div className='stat'>
                <h1 className='stat-header'>
                     $72m
                </h1>
                <p1 className = "stat-text">
                     in revenue generated by 2019
                </p1>
            </div>
            <div className='stat'>
                <h1 className='stat-header'>
                    500000
                </h1>
                <p1 className="stat-text" >
                    customers enrolled on loyalty program
                </p1>
            </div>
           </div>
            <div className='doc'>
                <h1 className='doc-text'>Watch the documentary</h1>
            </div>
            <div className='vid-frame videoWrapper'>
                 <iframe className='yt-vid' width="1450" height="815" src="https://www.youtube.com/embed/e7a_rkxxzG8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture & muted=1" allowfullscreen></iframe>
            </div>
            <div className='back-to-casestudy'>
                 <button className="btn btn-back-to-casestudy" onClick={handleEnter}>
                    <div className='back-btns'>
                        <BsArrowLeft className='arrow'/>
                        <div className='back-text'>
                            Back to casestudy
                        </div>
                    </div>
                    </button>
            </div>
            <Footer />
        </div>
    )
}